import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Card, Price, MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { IconLinkWithFallback } from '../../../IconLinkWithFallback/IconLinkWithFallback.js';
import { AccordionItem } from '../../components/AccordionItem/AccordionItem.js';
import { Discount } from '../../components/Discount/Discount.js';
import '../../components/PrescriptionTable/PrescriptionTable.js';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/forms';
import '@grandvisionhq/icons';
import { useLineItemSlots } from '../../slots/context.js';

const PriceDetails = ({ currency , billingFrequency , discount , originalPrice  })=>{
    if (billingFrequency) {
        return /*#__PURE__*/ React.createElement(Card.Text, {
            variant: "caption",
            color: "text-secondary"
        }, `/ ${billingFrequency}`);
    }
    if (discount && originalPrice) {
        return /*#__PURE__*/ React.createElement(Card.Text, {
            variant: "caption",
            color: "text-secondary"
        }, /*#__PURE__*/ React.createElement(Price, {
            type: "strikethrough",
            value: originalPrice,
            size: "small",
            currency: currency
        }));
    }
    return null;
};
const LineItemCard = ({ billingFrequency , currency , discount , originalPrice , price , quantity , subtitle , title , relativeDiscount , isCompactCard , imagePath , imageHref , imageAlt ='' , isMini =false , hasDiscountSection =false , quoteConfig =undefined , accordionSection , additionalInfo , isContainerBasedLayout =false  })=>{
    const { useIsPhone  } = MediaQuery;
    const isPhone = useIsPhone();
    const { getLabel  } = useIntl();
    const { Slots  } = useLineItemSlots();
    const discountLabel = {
        discount: getLabel('cart.item.discount')
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Card.Section, {
        className: `${isContainerBasedLayout ? 'container-type-inline-size' : ''}`
    }, /*#__PURE__*/ React.createElement(Card, {
        className: classnames('line-item-card', {
            'auto-layout': isContainerBasedLayout
        }),
        layout: !isMini && (isPhone || isCompactCard) ? 'vertical' : 'horizontal',
        key: title,
        "data-t": "line-item-card"
    }, /*#__PURE__*/ React.createElement(Card.Image, {
        imageHref: imageHref,
        alt: imageAlt,
        backgroundColor: "var(--color--shade-lightest)",
        className: classnames('line-item-card__image', {
            'card-base__image--mini': isMini
        }),
        src: imagePath
    }), /*#__PURE__*/ React.createElement(Card.Content, {
        childrenWrapperClassName: classnames('line-item-card__wrapper', {
            'line-item-card__wrapper--regular': !isCompactCard,
            'line-item-card__wrapper--mini': isMini
        })
    }, /*#__PURE__*/ React.createElement(Card.Section, {
        className: classnames('line-item-card__details', {
            'line-item-card__details--compact': isPhone || isCompactCard
        })
    }, /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Section, null, title ? /*#__PURE__*/ React.createElement(Card.Heading, {
        component: "h2",
        variant: "subheading1"
    }, title) : null), subtitle ? /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "none",
        flex: true,
        className: "line-item-card__subtitle",
        "data-t": "line-item-card-subtitle"
    }, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "caption",
        color: "text-secondary"
    }, subtitle)) : null, additionalInfo && additionalInfo.length > 0 ? /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "none"
    }, additionalInfo.map((info, i)=>/*#__PURE__*/ React.createElement(Card.Text, {
            key: i,
            variant: "caption",
            color: "text-secondary"
        }, info)
    )) : null, !Slots.QuantitySelector && /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "s"
    }, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "caption"
    }, quantity))), /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "none",
        className: "line-item-card__price"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "line-item-card__price-container"
    }, Slots.PriceTooltip ? /*#__PURE__*/ React.createElement(Slots.PriceTooltip, null) : null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "caption"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: price,
        size: "small",
        currency: currency,
        "data-t": "line-item-card-price"
    })))), /*#__PURE__*/ React.createElement(PriceDetails, {
        currency: currency,
        billingFrequency: billingFrequency,
        discount: discount,
        originalPrice: originalPrice
    }), hasDiscountSection && discount ? /*#__PURE__*/ React.createElement(Card.Text, null, /*#__PURE__*/ React.createElement(Discount, {
        absoluteValue: discount,
        relativeValue: relativeDiscount,
        currency: currency,
        labels: discountLabel
    })) : null), Slots.QuantitySelector || Slots.StockAndDelivery ? /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "none",
        className: "line-item-card__action"
    }, Slots.QuantitySelector && /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "none",
        className: "line-item-card__quantity"
    }, /*#__PURE__*/ React.createElement(Slots.QuantitySelector, null)), Slots.StockAndDelivery && /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "none",
        className: "line-item-card__stock"
    }, /*#__PURE__*/ React.createElement(Slots.StockAndDelivery, null))) : null, Slots.DeliveryEstimation ? /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "m",
        className: "line-item-card__delivery-estimation"
    }, /*#__PURE__*/ React.createElement(Slots.DeliveryEstimation, null)) : null), accordionSection && accordionSection.length > 0 ? /*#__PURE__*/ React.createElement(Card.Section, null, accordionSection.map((section, i)=>{
        const id = `${section.title}-${i}`;
        return /*#__PURE__*/ React.createElement(AccordionItem, swcHelpers.extends({
            key: id,
            id: id
        }, section));
    })) : null, quoteConfig ? /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "none",
        className: "line-item-card__quotation"
    }, /*#__PURE__*/ React.createElement(IconLinkWithFallback, {
        url: quoteConfig.quoteUrl,
        hasLink: quoteConfig.hasQuoteLink,
        labels: {
            fallback: getLabel('products.contactLenses.quotation'),
            linkCaption: getLabel('products.contactLenses.quotationPrint')
        }
    })) : null, Slots.Reorder ? /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "none",
        className: "line-item-card__reorder"
    }, /*#__PURE__*/ React.createElement(Slots.Reorder, null)) : null))), Slots.Footer ? /*#__PURE__*/ React.createElement(Slots.Footer, null) : null);
};

export { LineItemCard };
//# sourceMappingURL=LineItemCard.js.map
